<template>
  <div class="form-element" :class="{ '-login': isLoginPage }">
    <label class="form-element__title" v-if="title">{{ title }}</label>
    <input
      v-numeric="true"
      class="form-element__input"
      :class="classObject"
      type="tel"
      name="tckn"
      placeholder="T.C. Kimlik Numarası"
      minlength="11"
      maxlength="11"
      autocomplete="off"
      @input="changed"
      v-model.trim="val"
    />
    <div
      class="form-element__message"
      :class="{ '-error': isError }"
      v-if="message"
    >
      {{ message }}
    </div>
  </div>
</template>

<script>
import { numeric } from "@/directives/";
export default {
  props: {
    value: {
      type: [String, Number],
      default: null,
    },
    isSecondary: {
      type: Boolean,
      default: false,
    },
    isError: {
      type: Boolean,
      default: false,
    },
    isBorder: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: null,
    },
    message: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      val: this.value,
      isLoginPage: this.$route.meta.layout == "login",
    };
  },
  computed: {
    classObject: function () {
      let list = {
        "-secondary": this.isSecondary,
        "-error": this.isError,
        "-border": this.isBorder,
      };

      return list;
    },
  },
  directives: { numeric },
  methods: {
    changed: function (e) {
      let status = this.checkTckn(e.target.value);

      if (!status) return this.$emit("input", null);

      this.$emit("input", e.target.value);

      return e.target.value;
    },
    checkTckn: function (tckn) {
      tckn = tckn.toString();
      let isEleven = /^[0-9]{11}$/.test(tckn);
      let totalX = 0;
      for (let i = 0; i < 10; i++) {
        totalX += Number(tckn.substr(i, 1));
      }
      let isRuleX = totalX % 10 == tckn.substr(10, 1);
      let totalY1 = 0;
      let totalY2 = 0;
      for (let i = 0; i < 10; i += 2) {
        totalY1 += Number(tckn.substr(i, 1));
      }
      for (let i = 1; i < 10; i += 2) {
        totalY2 += Number(tckn.substr(i, 1));
      }
      let isRuleY = (totalY1 * 7 - totalY2) % 10 == tckn.substr(9, 0);

      return isEleven && isRuleX && isRuleY;
    },
  },
};
</script>